<template>
  <div id="UserList">
    <table>
      <th>
        <td>
          UTENTI COLLEGATI
        </td>
        <td>
          <input
            class="input-text search-table"
            type="text"
            v-model="query.q"
            placeholder="Cerca utente..."
            @input="search"
          />
        </td>
        <td v-if="users.meta.last_page > 1" class="margin">
          <div class="pagination">
            <a v-on:click="firstPage()" v-if="users.meta.current_page > 2">&laquo;</a>
            <a v-on:click="previousPage()" v-if="users.meta.current_page > 1">{{ users.meta.current_page - 1 }}</a>
            <a class="active">{{ users.meta.current_page }}</a>
            <a v-on:click="nextPage()" v-if="users.meta.current_page < users.meta.last_page">{{ users.meta.current_page + 1 }}</a>
            <a v-on:click="lastPage()" v-if="users.meta.current_page + 1 < users.meta.last_page">&raquo;</a>
          </div>
        </td>
      </th>
      <tr v-for="user in users.data" v-bind:key="user.id">
        <td>{{ user.name }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UsersList",
  data() {
    return {
      query: {
        q: "",
        orderBy: "name",
        order: "ASC",
        page: 1,
        limit: 15
      },
      loading: false,
    };
  },
  mounted() {
    window.Echo.channel("users").listen("CreatedUserEvent", e => {
      this.$store.commit("user/addedUser", e);
    });
    window.Echo.channel("users").listen("DeletedUserEvent", e => {
      this.$store.commit("user/deletedUser", e);
    });
  },
  beforeDestroy() {
    window.Echo.channel("users")
      .stopListening("CreatedUserEvent")
      .stopListening("DeletedUserEvent");
  },
  computed: {
    ...mapState({
      users: state => {
        return state.user.users;
      }
    }),
  },
  created() {
    this.loading = true;
    this.loadData();
  },
  methods: {
    loadData() {
      this.$store.dispatch("user/fetchUsers", this.query).then(() => {
        this.loading = false;
      });
    },
    search() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.query.page = 1;
        this.loadData();
      }, 200);
    },
    firstPage() {
      if (this.loading) return;
      this.loading = true;
      this.query.page = 1;
      this.loadData();
    },
    lastPage() {
      if (this.loading) return;
      this.loading = true;
      this.query.page = this.users.meta.last_page;
      this.loadData();
    },
    nextPage() {
      if (this.loading) return;
      this.loading = true;
      this.query.page = this.users.meta.current_page + 1;
      this.loadData();
    },
    previousPage() {
      if (this.loading) return;
      this.loading = true;
      this.query.page = this.users.meta.current_page - 1;
      this.loadData();
    }
  }
};
</script>
<style scoped>
#UserList {
  display: flex;
  justify-content: center;
}
table {
  border: 2px solid black;
  padding-bottom: .5em;
}
td {
    padding-left: .5em;
    padding-right: .5em;
    color: black;
}
th {
  background-color: black;
}
th > td {
  color: white;
  display: flex;
  justify-content: center;
}
input {
  margin-bottom: 0.5em;
}
.margin {
  margin-bottom: 0.5em;
}
.pagination {
  display: inline-block;
  border: 1px solid white;
}

.pagination a {
  color: white;
  float: left;
  padding: 5px 10px;
  text-decoration: none;
}

.pagination a.active {
  background-color: lightseagreen;
  color: black;
}

.pagination a:hover:not(.active) {
  background-color: white;
  color: black;
}
</style>
